import { styled, Wizard } from '@driftt/dds'

export const StyledStepContainer = styled(Wizard.StepColumn, {
  maxWidth: '688px',
  margin: '0 auto',
  padding: '$8',
  paddingTop: '$4',
})
